<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202309_01.jpg">
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left">女性の肌も、男性の肌も。</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">美しい肌に、垣根はない。</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202309_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">原点は同じ。<br>それは生まれたときの美しい素肌</h3>
        <p class="mb-3">赤ちゃんのお肌は、みんなもちもちで潤いに満ちた純粋無垢な美肌です。</p>
        <p class="mb-3">そこから年齢を重ねるにつれて、美肌の人とそうでない人と、お肌に変化が起こるのはなぜでしょう。</p>
        <p class="mb-3">もちろん体質もありますが、いかにしっかりと日常から正しいケアを日々行なっているかがポイントです。</p>
        <p class="mb-3">その大切さは女性も、男性も変わりません。特に昨今は男性も美肌に対する価値の意識が変わってきています。</p>
        <p>その背景にはジェンダーフリーに対する価値観に加え、美しい肌の方が若々しく見える点も理由の一つでしょう。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">知っていますか？<br>実は男性の方がお肌が弱いこと</h3>
        <p class="mb-3">意外に知らない方が多い、この事実。男性の方が肌が強いと思われがちですが、まずは男女の肌について比較してみましょう。</p>
        <p class="mb-3">男性は皮膚が厚く、皮脂分泌量は女性の2〜3倍といわれています。さらに潤いを維持するお肌の角層細胞の数が少なく、水分が蒸散しやすい。</p>
        <p class="mb-3">つまり過剰な皮脂を洗い流す「洗顔」と、保湿する「うるおいケア」がとても大切です。</p>
        <p>さらに紫外線ケアが日常的ではなかったり、髭剃りなど女性よりも外的刺激の要因が多いことも、男性が女性よりもお肌が弱くケアが必要と言われる所以のひとつです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202309_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202309_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">女性のお肌はバランスの良いケアがポイント</h3>
        <p class="mb-3">では女性のお肌はどうでしょう。男性に比べ皮膚が薄いことは事実ですが、皮脂分泌量は20代をピークに落ち着いてきます。</p>
        <p class="mb-3">その分、乾燥しやすくなり「うるおいケア」がやはりポイントになります。</p>
        <p class="mb-3">女性は若い時から紫外線ケアや洗顔、基礎化粧品を習慣化している人も多く、美肌の方も多いです。</p>
        <p class="mb-3">しかし美肌へ意識が高い故に、洗顔など基礎のケアは簡単にすませ、美容液などだけをしっかり行う方も多いのは事実。</p>
        <p>お肌の基礎ケアは日常の優しい丁寧な洗顔と、日々の保湿ケアであることは忘れられがちです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">女性も男性も、美肌へのアプローチは同じ。<br>基本のケアが大切な理由</h3>
        <p class="mb-3">女性も男性もお肌の特性はちがっても、大切なのは基礎である<strong>「洗顔」</strong>と<strong>「保湿」</strong>です。</p>
        <p class="mb-3">理由はとてもシンプル。</p>
        <p class="mb-3">洗顔は、余分や皮脂や汚れを落とすことはもちろん、お肌を健やかに保ち、スキンケアの受け入れ態勢を整えるため。</p>
        <p class="mb-3">保湿は、洗顔後の清潔なお肌にうるおいを与える水分を閉じ込めるため。</p>
        <p>この2ステップがあってこそ、美容液などスペシャルケアがより効果を発揮するのです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202309_05.jpg">
      </div>
    </div>

    <h2 class="mt-5 pt-5">シンプルで大切な「洗顔」と「保湿」<br>美肌ケアに性別は関係ありません。</h2>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_04.jpg">
      <div class="layer-text">
        <p class="mb-3">マナビス化粧品は</p>
        <p class="mb-3 fs-2">全ての人のための基礎化粧品</p>
        <p class="mb-3">簡単だけど丁寧なルーティンケアの積み重ね。</p>
        <p class="mb-3">丁寧な「洗顔」と「保湿」<br>素肌をもっちり「上質な泡」で優しく包み込み<br>無垢で清潔な状態のお肌をしっかりと「保湿」する。</p>
        <p>女性も男性も年齢に関係なく<br>毎日できる大切なスキンケアは「洗顔」と「保湿」なのです。</p>
      </div>
    </div>

    <h2 class="my-5 pt-5">基本のスキンケアアイテム</h2>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュd<br>薬用スキンウォッシュ チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">毎朝晩の洗顔に。</p>
        <p class="mb-3">うるおいはそのままに、やわらかな泡で包むように洗う。</p>
        <p>16種類の植物由来成分配合のアミノ酸系弱酸性ジェル状せっけん。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwashd_skinwashtube_202309.jpg">
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・初めて使った時に、洗い上がりに潤いが残っていて、驚きました。とても良いです。私は化学香料が苦手ですが、マナビスさんのものは匂いがなく、気持ちよく使用することができます。今後も使いたい、素敵な商品です。</p>
      <p class="mb-3">・長年愛用していますがチューブタイプが発売されて、主人も一緒に使いやすくなり嬉しいです。家族みんなのお気に入りです。</p>
      <p>・毛穴の中まできれいなったと感じている。クスミが取れてトーンが明るくなった。使ったその日にすぐ、これは違う！汚れがちゃんと落ちていると実感した。</p>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_skinmasktube_202309.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンマスク<br>薬用スキンマスク チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">インバスケアで保湿革命。</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状のテクスチャーでお風呂でも使えるアイテムです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・使用後かなりツルツルになりました。 肌の柔軟性もアップし、化粧水の入りもいいと思います。 パック特有の洗い流しづらさもなく良かったです。</p>
      <p class="mb-3">・クスミがとれた。敏感肌でパックとか使うのが怖かったが、トラブルなく毎日使ってる。</p>
      <p>・スキンマスクを使用した後、明らかにお肌が「つるっ」っとして感動しました。私は顔に以外にも、デコルテや手の甲、肘など乾燥の気になる様々な箇所に使用しています。</p>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用エモリエントローション EX</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">洗顔後の素肌を、より、みずみずしく。</p>
        <p class="mb-3">細かな霧がお肌に心地よくなじみ、キメを整えます。</p>
        <p>使いやすいミストタイプの化粧水。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_lotion_202309.jpg">
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・スプレータイプなのでメイク直しにも使えて、ワンプッシュで顔全体にかかってくれるので良いです！</p>
      <p class="mb-3">・敏感肌なので痒くならないか心配してましたが大丈夫でした。容器がスプレーなので化粧水が均等に肌に行き渡ります。季節的に肌が乾燥してるので化粧水をつけた瞬間肌に浸透しているのが分かります。</p>
      <p>・お肌の調子は良い。ニキビも無くなり小鼻のザラザラ感も無くなった。肌の色も美白になってきて凄く良いです。</p>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_moisturegel_202309.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>モイスチャージェルセット</h3>
        <p class="mb-3">¥6,000</p>
        <p class="mb-3">乾燥による小ジワ、目立たない*肌へ。</p>
        <p class="mb-3">注目の美容成分エクトインと、ヒト型セラミドを贅沢に配合。</p>
        <p class="mb-3">角質細胞間脂質の成分を補うことで与えた水分を逃さない。</p>
        <p class="mb-3">お肌のバリア機能を助けるジェル状保湿液。</p>
        <p>*効能評価試験済み</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・塗るときに良くのび、ずっとしっとり感があります。冬に乾燥が気になるところに使用。ベタつかないしっとり感が良いと思いました。</p>
      <p class="mb-3">・伸びが良く、香りが抑えられてるので、男性でも使いやすいです。</p>
      <p>・しっとり感がちょうど良かった。 リフィルの容器を使ったが、付け替えは簡単で使い易くエコでいいと思いました。</p>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">SPECIAL<br>リフトセラム</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">キメの整った上質なハリ肌へ。</p>
        <p class="mb-3">今、注目の美容成分エクトイン。</p>
        <p class="mb-3">そして美肌に大切な、ヒアルロン酸4種を配合。</p>
        <p>肌なじみの良さに定評のある美容液。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_liftserum_202309.jpg">
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・肌が、いきいきすることを実感した。伸びが良く、顔全体に広げやすくて良いと思います。</p>
      <p class="mb-3">・たまにの使用だが、使うとやっぱり肌のハリが違う。継続するとよさそう。</p>
      <p>・今までスキンケアを真面目にした事が無かったんですが、他のアイテムも使ってみようかな‥と思ったくらい、使い心地が良かったです。</p>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_whiteningessence_202309.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>薬用ホワイトニングエッセンス EX</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">なめらかで透明感のある肌へ。</p>
        <p class="mb-3">叶えたいのは、しなやかで明るい健やかな肌。</p>
        <p class="mb-3">頼もしい美容成分をたっぷり配合。</p>
        <p>しっとりとなじむ美白美容液。。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="pb-5">
      <p class="mb-3"><strong>お客様の声</strong></p>
      <p class="mb-3">・しっとり保湿されるのにベタつかず、使いやすく重宝しています。</p>
      <p class="mb-3">・肌にしっかりと馴染むので安心感がある。ツヤも出てきました。肌を友人に褒められることが増え、効果が出ているように思います。</p>
      <p>・つけた翌朝の肌が違う。混合肌ですが、ツヤが出ていて感動しました。継続して使っていきたい。</p>
    </div>
   
    <div class="layer_02 mt-5 pt-5">
      <img src="@/assets/img/column/202309_06.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left">ともに美しく。</h2>
        </div>
      </div>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_04.jpg');
  background-size: cover;
  background-position: center;
  min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  left: 25px;
  bottom: 20px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}
.layer_02 {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/column/202309_06.jpg');
  background-size: cover;
  min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 60px; /* テキストと画像の端の間に余白を設定 */
  background-position: center;
}
.layer_02 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_02 .layer-text .layer-text-inner h2 {
  font-size: 2.5em;
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_02 {
    min-height: 300px;
    padding: 15px;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
  .layer_01 {
    background-image: url('../../assets/img/column/layer-bg_04_sp.jpg');
    min-height: 500px;
  }
  .layer_02 .layer-text .layer-text-inner h2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>